var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.fieldComponents, function(field) {
      return _c(
        "div",
        {
          key: field.id,
          staticClass: "df-field",
          class: {
            "has-value": _vm.getModelValue(field.schema),
            "has-focus": _vm.hasFocus || _vm.autofilled
          }
        },
        [
          _c(field.component, {
            ref: field.key,
            refInFor: true,
            tag: "component",
            attrs: {
              id: field.id,
              "data-df-key": field.key,
              "data-full-story": field.showFullStory,
              locale: _vm.locale,
              schema: field.schema,
              value: _vm.getModelValue(field.schema)
            },
            on: {
              input: function($event) {
                return _vm.setModelValue(field.schema, $event)
              },
              focus: function($event) {
                _vm.hasFocus = true
              },
              blur: function($event) {
                _vm.hasFocus = false
              },
              animationstart: _vm.checkAnimation
            }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }